(function () {
  'use strict';

  /* ---------- utilitaires ---------- */
  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (format && format.indexOf('{{') > -1) ? format.replace(/\{\{\s*\w+\s*\}\}/, v) : v + ' €';
  }
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmtDay(d) {
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' }).replace('.', '');
  }

  /* ---------- date de livraison ---------- */
  var etaMin = document.querySelectorAll('[data-eta-min]');
  var etaMax = document.querySelectorAll('[data-eta-max]');
  if (etaMin.length) {
    var now = new Date();
    var a = fmtDay(addBusinessDays(now, (window.SDT && SDT.deliveryMin) || 6));
    var b = fmtDay(addBusinessDays(now, (window.SDT && SDT.deliveryMax) || 10));
    etaMin.forEach(function (el) { el.textContent = a; });
    etaMax.forEach(function (el) { el.textContent = b; });
  }

  /* ---------- compte à rebours Noël ---------- */
  var xmas = document.querySelector('[data-xmas]');
  if (xmas) {
    var xEnd = new Date(xmas.getAttribute('data-end')).getTime(), xEl = xmas.querySelector('[data-xmas-left]');
    var xTick = function () {
      var s = Math.floor((xEnd - Date.now()) / 1000);
      if (!(s > 0)) { xmas.hidden = true; return; }
      var j = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      xEl.textContent = j + ' j ' + h + ' h ' + (m < 10 ? '0' : '') + m + ' min ' + (sec < 10 ? '0' : '') + sec + ' s';
    };
    xTick(); setInterval(xTick, 1000);
  }

  var root = document.querySelector('[data-configurator]');
  if (!root) return;

  var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
  var moneyFormat = root.getAttribute('data-money-format');
  var variantsByModel = { bracelet: variants, collier: JSON.parse(root.getAttribute('data-variants-collier') || '[]') };
  var model = 'bracelet';
  var svg, photoEl, line1El, line2El;
  function bindArt() {
    svg = root.querySelector('[data-model-art="' + model + '"] [data-bracelet]') || root.querySelector('[data-bracelet]');
    photoEl = svg.querySelector('[data-photo]');
    line1El = svg.querySelector('[data-line1]');
    line2El = svg.querySelector('[data-line2]');
  }
  bindArt();

  function newState() { return { file: null, img: null, zoom: 1, ox: 0, oy: 0, preview: '', color: 'Argent', l1: '', l2: '', font: 'Classique' }; }
  var FONTS = { 'Classique': { css: 'GravLato, sans-serif', ref: 'n°2 Lato', k: 0.5 }, 'Élégante': { css: 'GravBask, serif', ref: 'n°3 Libre Baskerville', k: 0.56 }, 'Manuscrite': { css: 'GravVibes, cursive', ref: 'n°9 Great Vibes', k: 0.42 } };
  var states = [newState(), newState()];
  var active = 0;
  // formule par défaut : le coffret (écrin offert) s'il existe
  function defVariant(list) { var c = list.filter(function (v) { return /coffret/i.test(v.title || '') && v.available !== false; })[0]; return (c || list[0] || {}).id || null; }
  var variantId = variants.length ? defVariant(variants) : null;
  var secondMode = 'same';

  /* ---------- chaleur (révélation) ---------- */
  var reveal = 0, heat = 0, target = 0, speed = 0.05, raf = null, coolTimer = null;
  function tick() {
    reveal += (target - reveal) * speed;
    heat += ((target > 0 ? 1 : 0) - heat) * 0.08;
    if (Math.abs(target - reveal) < 0.002 && Math.abs((target > 0 ? 1 : 0) - heat) < 0.002) {
      reveal = target; heat = target > 0 ? 1 : 0; raf = null;
    } else { raf = requestAnimationFrame(tick); }
    svg.style.setProperty('--reveal', reveal.toFixed(3));
    svg.style.setProperty('--heat', heat.toFixed(3));
  }
  function run() { if (!raf) raf = requestAnimationFrame(tick); }
  function warm() { clearTimeout(coolTimer); setFace('front'); target = 1; speed = 0.06; run(); }
  function cool(delay) {
    clearTimeout(coolTimer);
    coolTimer = setTimeout(function () { target = 0; speed = 0.018; run(); }, delay == null ? 900 : delay);
  }
  function demo() { warm(); cool(1500); }

  var heatBtn = root.querySelector('[data-heat-btn]');
  var art = root.querySelector('[data-heat-target]');
  [heatBtn, art].forEach(function (el) {
    el.addEventListener('pointerdown', function (e) { e.preventDefault(); warm(); el === heatBtn && heatBtn.classList.add('is-hot'); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (t) {
      el.addEventListener(t, function () { if (target === 1) cool(); heatBtn.classList.remove('is-hot'); });
    });
    el.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  });
  heatBtn.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); warm(); } });
  heatBtn.addEventListener('keyup', function () { cool(); });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { setTimeout(demo, 500); io.disconnect(); } }, { threshold: 0.5 });
    io.observe(svg);
  }

  /* ---------- recto / verso ---------- */
  var faceBtns = root.querySelectorAll('[data-face]');
  function setFace(f) {
    svg.classList.toggle('is-back', f === 'back');
    faceBtns.forEach(function (b) { var on = b.getAttribute('data-face') === f; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
  }
  faceBtns.forEach(function (b) { b.addEventListener('click', function () { setFace(b.getAttribute('data-face')); }); });

  /* ---------- photo + recadrage ---------- */
  var fileInput = root.querySelector('[data-file]');
  var drop = root.querySelector('[data-drop]');
  var crop = root.querySelector('[data-crop]');
  var cropBox = root.querySelector('[data-crop-box]');
  var cropImg = root.querySelector('[data-crop-img]');
  var zoomInput = root.querySelector('[data-zoom]');
  var photoErr = root.querySelector('[data-photo-err]');
  var stepPhoto = root.querySelector('[data-step="photo"]');

  function showPhotoErr(msg) { photoErr.textContent = msg; photoErr.hidden = !msg; }

  var HEIC_LIB = 'https://cdn.jsdelivr.net/npm/heic-to@1.6.5/dist/iife/heic-to.js';
  function isHeic(file) { return /hei[cf]/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || ''); }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (window.HeicTo) return res();
      var sc = document.createElement('script'); sc.src = src; sc.onload = res; sc.onerror = rej; document.head.appendChild(sc);
    });
  }
  // Les photos iPhone (HEIC) ne sont pas lisibles par Chrome/Firefox : on les convertit en JPG
  function toJpeg(file) {
    var dropTitle = drop.querySelector('.drop__title'), prev = dropTitle.textContent;
    dropTitle.textContent = 'Préparation de ta photo…';
    return loadScript(HEIC_LIB).then(function () {
      return window.HeicTo({ blob: file, type: 'image/jpeg', quality: 0.92 });
    }).then(function (out) {
      dropTitle.textContent = prev;
      var b = Array.isArray(out) ? out[0] : out;
      return new File([b], (file.name || 'photo').replace(/\.(heic|heif)$/i, '') + '.jpg', { type: 'image/jpeg' });
    }, function (e) { dropTitle.textContent = prev; throw e; });
  }

  function useImage(file) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var s = states[active];
      s.file = file; s.img = img; s.zoom = 1; s.ox = 0; s.oy = 0;
      render();
      demo();
      // Photo trop petite (ex. image envoyée par WhatsApp) : on prévient, sans bloquer
      if (Math.min(img.naturalWidth, img.naturalHeight) < 600) {
        showPhotoErr('Cette photo est de petite taille, elle risque d’être un peu floue sur le bijou. Si tu peux, choisis l’originale depuis ta galerie.');
      }
    };
    img.onerror = function () {
      if (isHeic(file)) return convertAndUse(file);
      showPhotoErr('Impossible de lire cette photo. Essaie avec une image JPG ou PNG (ou une capture d’écran).');
    };
    img.src = url;
  }
  function convertAndUse(file) {
    toJpeg(file).then(useImage, function () {
      showPhotoErr('Cette photo iPhone (HEIC) n’a pas pu être lue. Essaie une capture d’écran de la photo, ou choisis-la depuis ton téléphone.');
    });
  }

  function loadFile(file) {
    showPhotoErr('');
    if (!file) return;
    if (!/^image\//.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) { showPhotoErr('Ce fichier n’est pas une photo. Choisis une image JPG ou PNG.'); return; }
    if (file.size > 20 * 1024 * 1024) { showPhotoErr('Cette photo est trop lourde (20 Mo max).'); return; }
    useImage(file);
  }
  fileInput.addEventListener('change', function () { loadFile(fileInput.files[0]); fileInput.value = ''; });
  ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer.files[0]) loadFile(e.dataTransfer.files[0]); });
  root.querySelector('[data-change]').addEventListener('click', function () { fileInput.click(); });

  function boxSize() { return cropBox.clientWidth || 150; }
  function geometry(s, size) {
    var base = Math.max(size / s.img.naturalWidth, size / s.img.naturalHeight);
    var sc = base * s.zoom;
    var w = s.img.naturalWidth * sc, h = s.img.naturalHeight * sc;
    var mx = (w - size) / 2, my = (h - size) / 2;
    return { sc: sc, w: w, h: h, mx: mx, my: my };
  }
  function clamp(s) {
    var g = geometry(s, 1000);
    s.ox = Math.max(-g.mx, Math.min(g.mx, s.ox));
    s.oy = Math.max(-g.my, Math.min(g.my, s.oy));
  }
  // ox/oy exprimés dans un repère de 1000 px (indépendant de la taille d'écran)
  function drawTo(s, size) {
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, size, size);
    var g = geometry(s, size), k = size / 1000;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(s.img, (size - g.w) / 2 + s.ox * k, (size - g.h) / 2 + s.oy * k, g.w, g.h);
    return c;
  }
  var previewQueued = false;
  function updatePreview() {
    if (previewQueued) return; previewQueued = true;
    requestAnimationFrame(function () {
      previewQueued = false;
      var s = states[active];
      if (s.img) { s.preview = drawTo(s, 360).toDataURL('image/jpeg', 0.86); }
      paintBracelet();
    });
  }
  function layoutCrop() {
    var s = states[active]; if (!s.img) return;
    var size = boxSize(), g = geometry(s, size), k = size / 1000;
    cropImg.style.width = g.w + 'px'; cropImg.style.height = g.h + 'px';
    cropImg.style.transform = 'translate(calc(-50% + ' + (s.ox * k) + 'px), calc(-50% + ' + (s.oy * k) + 'px))';
  }

  var drag = null;
  cropBox.addEventListener('pointerdown', function (e) {
    if (!states[active].img) return;
    cropBox.setPointerCapture(e.pointerId);
    drag = { x: e.clientX, y: e.clientY, ox: states[active].ox, oy: states[active].oy };
  });
  cropBox.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var s = states[active], k = 1000 / boxSize();
    s.ox = drag.ox + (e.clientX - drag.x) * k;
    s.oy = drag.oy + (e.clientY - drag.y) * k;
    clamp(s); layoutCrop(); updatePreview();
  });
  ['pointerup', 'pointercancel'].forEach(function (t) { cropBox.addEventListener(t, function () { drag = null; }); });
  zoomInput.addEventListener('input', function () {
    var s = states[active]; s.zoom = parseFloat(zoomInput.value); clamp(s); layoutCrop(); updatePreview();
  });

  /* ---------- couleur ---------- */
  var swatches = root.querySelectorAll('[data-color]');
  var colorLabel = root.querySelector('[data-color-label]');
  swatches.forEach(function (b) {
    b.addEventListener('click', function () { states[active].color = b.getAttribute('data-color'); render(); });
  });

  /* ---------- gravure ---------- */
  var lineInputs = root.querySelectorAll('[data-line]');
  var engraveHint = root.querySelector('[data-engrave-hint]');
  var ALLOWED = /[^A-Za-zÀ-ÖØ-öø-ÿŒœ0-9 .,'’\-&\/]/g;
  function onLine(input) {
    var clean = input.value.replace(ALLOWED, '');
    var removed = clean !== input.value;
    if (removed) { input.value = clean; }
    engraveHint.classList.toggle('is-warn', removed);
    engraveHint.textContent = removed ? 'Les symboles et emojis ne peuvent pas être gravés : lettres, chiffres et ponctuation simple uniquement.' : 'Lettres, chiffres et ponctuation simple · 13 caractères max par ligne';
    var n = input.getAttribute('data-line');
    states[active]['l' + n] = input.value;
    root.querySelector('[data-count="' + n + '"]').textContent = input.value.length + '/13';
    setFace('back'); paintBracelet();
  }
  lineInputs.forEach(function (i) {
    i.addEventListener('input', function () { onLine(i); });
    i.addEventListener('focus', function () { setFace('back'); });
  });
  root.querySelectorAll('[data-idea]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = lineInputs[0].value ? lineInputs[1] : lineInputs[0];
      if (lineInputs[0].value && lineInputs[1].value) i = lineInputs[0];
      i.value = b.getAttribute('data-idea').slice(0, 13); onLine(i);
    });
  });

  var fontBtns = root.querySelectorAll('[data-font]');
  fontBtns.forEach(function (b) {
    b.addEventListener('click', function () { states[active].font = b.getAttribute('data-font'); setFace('back'); render(); });
  });

  /* ---------- modèle : bracelet / collier ---------- */
  var modelBtns = root.querySelectorAll('[data-model]');
  var NOUN = { bracelet: 'bracelet', collier: 'collier' };
  function setModel(m) {
    if (!variantsByModel[m] || !variantsByModel[m].length) return;
    var face = svg.classList.contains('is-back') ? 'back' : 'front';
    model = m; variants = variantsByModel[m]; variantId = defVariant(variants);
    secondMode = 'same'; active = 0;
    root.querySelectorAll('[data-model-art]').forEach(function (el) { el.hidden = el.getAttribute('data-model-art') !== m; });
    root.querySelectorAll('[data-offers]').forEach(function (el) { el.hidden = el.getAttribute('data-offers') !== m; });
    document.querySelectorAll('[data-model-gallery]').forEach(function (el) { el.hidden = el.getAttribute('data-model-gallery') !== m; });
    document.querySelectorAll('[data-for]').forEach(function (el) { el.hidden = el.getAttribute('data-for') !== m; });
    var rose = root.querySelector('[data-color="Or rose"]');
    if (rose) rose.hidden = m === 'collier';
    states.forEach(function (s) { if (m === 'collier' && s.color === 'Or rose') s.color = 'Argent'; });
    var t = root.getAttribute('data-title-' + m); if (t) root.querySelector('[data-title]').textContent = t;
    cropBox.classList.toggle('crop__box--square', m === 'collier');
    root.querySelector('.second__q').innerHTML = 'Le 2<sup>e</sup> ' + NOUN[m] + ' :';
    root.querySelectorAll('[data-editor]').forEach(function (b, i) { b.textContent = (m === 'collier' ? 'Collier ' : 'Bracelet ') + (i + 1); });
    setRadio(modelBtns, function (b) { return b.getAttribute('data-model') === m; });
    bindArt(); reveal = 0; heat = 0; setFace(face); render(); demo();
  }
  modelBtns.forEach(function (b) { b.addEventListener('click', function () { setModel(b.getAttribute('data-model')); }); });

  /* ---------- formule ---------- */
  var offerBtns = root.querySelectorAll('[data-variant]');
  var secondBox = root.querySelector('[data-second]');
  var editorTabs = root.querySelector('[data-editor-tabs]');
  function currentVariant() { return variants.filter(function (v) { return v.id === variantId; })[0] || variants[0]; }
  function isLot() { var v = currentVariant(); return !!v && /2/.test(v.title); }
  offerBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      variantId = parseInt(b.getAttribute('data-variant'), 10);
      if (!isLot()) { secondMode = 'same'; active = 0; }
      render();
    });
  });
  root.querySelectorAll('[data-second-mode]').forEach(function (b) {
    b.addEventListener('click', function () {
      secondMode = b.getAttribute('data-second-mode');
      if (secondMode === 'same') active = 0;
      else { active = 1; editorTabs.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      render();
    });
  });
  root.querySelectorAll('[data-editor]').forEach(function (b) {
    b.addEventListener('click', function () { active = parseInt(b.getAttribute('data-editor'), 10); render(); });
  });

  /* ---------- rendu ---------- */
  function setSvgText(el, txt, y) {
    var f = FONTS[states[active].font] || FONTS['Classique'];
    el.setAttribute('y', y);
    el.style.fontFamily = f.css;
    el.style.fontStyle = 'normal';
    el.style.fontSize = Math.max(11, Math.min(20, Math.round(104 / (f.k * Math.max(txt.length, 1))))) + 'px';
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(document.createTextNode(txt));
  }
  function paintBracelet() {
    var s = states[active];
    svg.classList.toggle('is-gold', s.color === 'Or');
    svg.classList.toggle('is-rose', s.color === 'Or rose');
    svg.classList.toggle('is-black', s.color === 'Noir');
    svg.classList.toggle('has-photo', !!s.preview);
    photoEl.setAttribute('href', s.preview || '');
    var t1 = s.l1 || (s.l2 ? '' : 'Ton message'), t2 = s.l2 || '';
    var two = !!(t1 && t2);
    // Safari iOS ne redessine pas toujours un texte SVG modifié : on remplace le nœud
    var dy = svg.classList.contains('necklace') ? 10 : 0;
    setSvgText(line1El, two ? t1 : (t1 || t2), (two ? 296 : 307) + dy);
    setSvgText(line2El, two ? t2 : '', 320 + dy);
    svg.style.transform = svg.style.transform ? '' : 'translateZ(0)';
  }
  function setRadio(list, test) {
    list.forEach(function (b) { var on = test(b); b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
  }
  function render() {
    var s = states[active];
    // photo
    drop.hidden = !!s.img; crop.hidden = !s.img;
    stepPhoto.classList.toggle('is-done', !!s.img);
    if (s.img) { cropImg.src = s.img.src; zoomInput.value = s.zoom; requestAnimationFrame(layoutCrop); }
    // couleur
    setRadio(swatches, function (b) { return b.getAttribute('data-color') === s.color; });
    colorLabel.textContent = s.color;
    setRadio(fontBtns, function (b) { return b.getAttribute('data-font') === s.font; });
    // gravure
    lineInputs[0].value = s.l1; lineInputs[1].value = s.l2;
    root.querySelector('[data-count="1"]').textContent = s.l1.length + '/13';
    root.querySelector('[data-count="2"]').textContent = s.l2.length + '/13';
    // formule
    setRadio(offerBtns, function (b) { return parseInt(b.getAttribute('data-variant'), 10) === variantId; });
    var lot = isLot();
    secondBox.hidden = !lot;
    setRadio(root.querySelectorAll('[data-second-mode]'), function (b) { return b.getAttribute('data-second-mode') === secondMode; });
    editorTabs.hidden = !(lot && secondMode === 'custom');
    root.querySelectorAll('[data-editor]').forEach(function (b) {
      var on = parseInt(b.getAttribute('data-editor'), 10) === active;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on);
    });
    // prix
    var v = currentVariant();
    if (v) {
      var p = money(v.price, moneyFormat);
      root.querySelector('[data-price]').textContent = p;
      root.querySelector('[data-add-price]').textContent = p;
      var single = variants[0] ? variants[0].price : v.price;
      var was = lot ? single * 2 : 0, saved = was - v.price;
      var wasEl = root.querySelector('[data-was]'), saveEl = root.querySelector('[data-save]'), addWas = root.querySelector('[data-add-was]');
      var showWas = lot && saved > 0;
      if (wasEl) { wasEl.hidden = !showWas; wasEl.textContent = showWas ? money(was, moneyFormat) : ''; }
      if (addWas) { addWas.hidden = !showWas; addWas.textContent = showWas ? money(was, moneyFormat) : ''; }
      if (saveEl) { saveEl.hidden = !showWas; saveEl.textContent = showWas ? '−' + Math.round(saved / was * 100) + ' %' : ''; }
      var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = p;
    }
    if (s.img) updatePreview(); else { s.preview = ''; paintBracelet(); }
  }
  window.addEventListener('resize', layoutCrop);

  /* ---------- ajout au panier ---------- */
  var addBtn = root.querySelector('[data-add]');
  var addLabel = root.querySelector('[data-add-label]');
  var addErr = root.querySelector('[data-add-err]');
  // Photo originale réduite à 2400 px avant l'envoi (une photo d'iPhone de 3-5 Mo ralentissait l'ajout au panier en 4G)
  function shrinkOriginal(st) {
    if (!st || !st.file) return Promise.resolve(null);
    var im = st.img, w = im && im.naturalWidth, h = im && im.naturalHeight;
    if (!w || !h || (Math.max(w, h) <= 2400 && st.file.size < 1500000)) return Promise.resolve(st.file);
    var k = Math.min(1, 2400 / Math.max(w, h)), c = document.createElement('canvas');
    c.width = Math.round(w * k); c.height = Math.round(h * k);
    try { c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); } catch (e) { return Promise.resolve(st.file); }
    return new Promise(function (res) { c.toBlob(function (b) { res(b && b.size < st.file.size ? b : st.file); }, 'image/jpeg', 0.9); });
  }
  function toBlob(canvas) {
    return new Promise(function (res) { canvas.toBlob(function (b) { res(b); }, 'image/jpeg', 0.92); });
  }
  function engraving(s) { var t = [s.l1.trim(), s.l2.trim()].filter(Boolean).join(' / '); return t || 'Sans gravure'; }
  function fontRef(s) { var f = FONTS[s.font] || FONTS['Classique']; return s.font + ' (' + f.ref + ')'; }
  function fail(msg) { addErr.textContent = msg; addErr.hidden = false; }

  // Fichier de gravure prêt pour l'usine : texte noir sur fond transparent, 2000 px, police choisie
  function engraveFile(s) {
    var lines = [s.l1.trim(), s.l2.trim()].filter(Boolean);
    if (!lines.length) return Promise.resolve(null);
    var fam = (FONTS[s.font] || FONTS['Classique']).css.split(',')[0].trim();
    return document.fonts.load('200px ' + fam).then(function () {
      var c = document.createElement('canvas'); c.width = c.height = 2000;
      var ctx = c.getContext('2d');
      var size = 300;
      var widest = function () { ctx.font = size + 'px ' + fam; return Math.max.apply(null, lines.map(function (l) { return ctx.measureText(l).width; })); };
      while (size > 60 && (widest() > 1300 || size * 1.3 * lines.length > 1100)) size -= 6;
      ctx.font = size + 'px ' + fam; ctx.fillStyle = '#000'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var lh = size * 1.3, top = 1000 - (lh * (lines.length - 1)) / 2;
      lines.forEach(function (l, i) { ctx.fillText(l, 1000, top + i * lh); });
      return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/png'); });
    }).catch(function () { return null; });
  }

  addBtn.addEventListener('click', function () {
    addErr.hidden = true;
    var lot = isLot(), custom2 = lot && secondMode === 'custom';
    if (!states[0].img) {
      active = 0; render(); showPhotoErr('Ajoute ta photo pour créer ton ' + NOUN[model] + '.');
      stepPhoto.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
    }
    if (custom2 && !states[1].img) {
      active = 1; render(); showPhotoErr('Ajoute la photo du 2e ' + NOUN[model] + '.');
      stepPhoto.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
    }
    var confirmBox = root.querySelector('[data-confirm]');
    if (confirmBox && !confirmBox.checked) {
      fail('Coche la case pour confirmer ta photo et ta gravure : ton bijou sera fabriqué exactement ainsi.');
      confirmBox.closest('.confirm').classList.add('is-err');
      return;
    }
    addBtn.setAttribute('aria-busy', 'true'); addLabel.textContent = 'Envoi de ta photo…';
    var jobs = [toBlob(drawTo(states[0], 1000)), engraveFile(states[0])];
    if (custom2) jobs.push(toBlob(drawTo(states[1], 1000)), engraveFile(states[1]));
    var oi = jobs.length;
    jobs.push(shrinkOriginal(states[0]), custom2 ? shrinkOriginal(states[1]) : Promise.resolve(null));
    Promise.all(jobs).then(function (blobs) {
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      fd.append('properties[Bijou]', model === 'collier' ? 'Collier' : 'Bracelet');
      fd.append('properties[Couleur]', states[0].color);
      fd.append('properties[Photo]', blobs[0], 'photo-bracelet-1.jpg');
      fd.append('properties[Gravure]', engraving(states[0]));
      if (states[0].l1.trim() || states[0].l2.trim()) fd.append('properties[Écriture]', fontRef(states[0]));
      if (blobs[1]) fd.append('properties[_Fichier gravure]', blobs[1], 'gravure-1.png');
      if (blobs[oi] && blobs[oi].size < 10 * 1024 * 1024) fd.append('properties[_Photo originale]', blobs[oi], 'originale-1.jpg');
      if (lot) {
        if (custom2) {
          fd.append('properties[' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2 · Couleur]', states[1].color);
          fd.append('properties[' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2 · Photo]', blobs[2], 'photo-bracelet-2.jpg');
          if (blobs[3]) fd.append('properties[_' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2 · Fichier gravure]', blobs[3], 'gravure-2.png');
          fd.append('properties[' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2 · Gravure]', engraving(states[1]));
          if (states[1].l1.trim() || states[1].l2.trim()) fd.append('properties[' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2 · Écriture]', fontRef(states[1]));
          if (blobs[oi + 1] && blobs[oi + 1].size < 10 * 1024 * 1024) fd.append('properties[_Photo originale 2]', blobs[oi + 1], 'originale-2.jpg');
        } else {
          fd.append('properties[' + (model === 'collier' ? 'Collier' : 'Bracelet') + ' 2]', 'Identique au 1er');
        }
      }
      return fetch((window.SDT && SDT.cartAddUrl) || '/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });
    }).then(function () {
      addLabel.textContent = 'Ajouté ✓';
      window.location.href = (window.SDT && SDT.cartUrl) || '/cart';
    }).catch(function (e) {
      addBtn.removeAttribute('aria-busy'); addLabel.textContent = 'Ajouter au panier';
      fail('Oups, l’ajout n’a pas fonctionné (' + e.message + '). Réessaie dans un instant.');
    });
  });

  /* ---------- barre collante mobile ---------- */
  var sticky = document.querySelector('[data-sticky]');
  // visible dès qu'on commence à descendre, masquée quand la personnalisation est à l'écran
  if (sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var create = root.querySelector('#creer-bijou') || root.querySelector('[data-buy]');
    var inCreate = false;
    function upd() { sticky.classList.toggle('is-shown', window.scrollY > 220 && !inCreate); }
    new IntersectionObserver(function (es) { inCreate = es[0].isIntersecting; upd(); }, { threshold: 0 }).observe(create);
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  render();
})();

/* guide des tailles */
(function () {
  var open = document.querySelector('[data-size-open]'), dlg = document.querySelector('[data-size-dialog]');
  if (!open || !dlg || !dlg.showModal) return;
  open.addEventListener('click', function () { dlg.showModal(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
})();

/* visionneuse photos plein écran */
(function () {
  var dlg = document.querySelector('[data-lb]');
  if (!dlg || !dlg.showModal) return;
  var img = dlg.querySelector('[data-lb-img]'), count = dlg.querySelector('[data-lb-count]');
  var list = [], i = 0, x0 = null;
  function show() {
    img.src = list[i].dataset.full || list[i].currentSrc || list[i].src;
    img.alt = list[i].alt;
    count.textContent = (i + 1) + ' / ' + list.length;
  }
  function go(d) { i = (i + d + list.length) % list.length; show(); }
  document.querySelectorAll('[data-model-gallery]').forEach(function (gal) {
    gal.addEventListener('click', function (e) {
      var t = e.target.closest('img');
      if (!t) return;
      list = Array.prototype.slice.call(gal.querySelectorAll('img'));
      i = list.indexOf(t);
      show();
      dlg.showModal();
    });
  });
  dlg.querySelector('[data-lb-prev]').addEventListener('click', function () { go(-1); });
  dlg.querySelector('[data-lb-next]').addEventListener('click', function () { go(1); });
  dlg.querySelector('[data-lb-close]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') go(-1);
    if (e.key === 'ArrowRight') go(1);
  });
  dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  dlg.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    x0 = null;
  });
})();

/* case de confirmation + avis masqués tant qu'il n'y en a pas */
(function () {
  var box = document.querySelector('[data-confirm]');
  if (box) box.addEventListener('change', function () {
    box.closest('.confirm').classList.remove('is-err');
    var err = document.querySelector('[data-add-err]');
    if (err && box.checked) err.hidden = true;
  });
  if (document.querySelector('.jdgm-prev-badge[data-number-of-reviews="0"]')) {
    var avis = document.getElementById('avis');
    if (avis) (avis.closest('.shopify-section') || avis).style.display = 'none';
  }
})();

/* vidéos réelles : chargées et lancées seulement quand elles deviennent visibles */
(function () {
  var vids = document.querySelectorAll('[data-reel]'); if (!vids.length) return;
  function load(v) {
    var src = v.querySelector('source[data-src]');
    if (src && !src.src) { src.src = src.getAttribute('data-src'); v.load(); }
  }
  function start(v) {
    load(v);
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  // lecture au toucher (si le téléphone bloque la lecture automatique) + bouton ▶ tant qu'elle est en pause
  vids.forEach(function (v) {
    var wrap = document.createElement('span'); wrap.className = 'reel__wrap is-paused';
    v.parentNode.insertBefore(wrap, v); wrap.appendChild(v);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'reel__play'; btn.setAttribute('aria-label', 'Lire la vidéo');
    wrap.appendChild(btn);
    v.addEventListener('playing', function () { wrap.classList.remove('is-paused'); });
    v.addEventListener('pause', function () { wrap.classList.add('is-paused'); });
    wrap.addEventListener('click', function () { if (v.paused) { start(v); } else { v.pause(); } });
  });
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) start(e.target); else e.target.pause(); });
  }, { rootMargin: '200px' });
  vids.forEach(function (v) { io.observe(v); });
})();
